import { SIGLA_SAG_REVISAO_CTC, SIGLA_SAG_CANCELAR_CTC, SIGLA_SAG_SOLICITAR_CTC } from "./constants";

const INITIAL_STATE = {
    loading: false,
    cpf: '',
    protocolo: '',
    ctcTO: null,
    servicoSAGSolicitar: null,
    servicoSAGRevisar: null,
    servicoSAGCancelar: null,
    requererCtc: false,
    mensagem: '',
    impressaoSucesso: false,
    pedidosCTC: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CERTIDAO_TEMPO_CONTRIBUICAO_LOADING':
            return { ...state, loading: action.payload }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_ENCONTRADA':
            return { ...state, loading: false, requererCtc: false, protocolo: action.payload }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_PROTOCOLO_ENCONTRADA':
            return { ...state, loading: false, ctcTO: action.payload }

        case 'CTC_SERVICO_POR_SIGLA_SUCESSO':
            let servico = action.payload;
            let isRevisao = false;
            let isCancelar = false;
            let isSolicitar = false;
            if (servico) {
                if (servico.sigla === SIGLA_SAG_REVISAO_CTC) {
                    isRevisao = true;
                } else if (servico.sigla === SIGLA_SAG_CANCELAR_CTC) {
                    isCancelar = true;
                } else if (servico.sigla === SIGLA_SAG_SOLICITAR_CTC) {
                    isSolicitar = true;
                }
            }
            return { ...state, servicoSAGRevisar: isRevisao ? servico : state.servicoSAGRevisar, servicoSAGCancelar: isCancelar ? servico : state.servicoSAGCancelar, servicoSAGSolicitar: isSolicitar ? servico : state.servicoSAGSolicitar }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_NAO_ENCONTRADA':
            return { ...state, loading: false, requererCtc: true, cpf: '', protocolo: '', ctcTO: null }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_BAIXAR_DOCUMENTO_SUCESSO':
            return { ...state, loading: false, impressaoSucesso: true, mensagem: '' }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_MENSAGEM':
            return { ...state, loading: false, mensagem: action.payload, impressaoSucesso: false }

        case 'CERTIDAO_TEMPO_CONTRIBUICAO_LIMPAR_MENSAGEM':
            return { ...state, mensagem: '', impressaoSucesso: false }
        case 'CERTIDAO_TEMPO_CONTRIBUICAO_PEDIDOS_ENCONTRADOS':
            return {...state, pedidosCTC: action.payload}
        default:
            return state;
    }
}
